import { Button } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme, { backgroundColor }) => ({
  shipBackButtonStyle: {
    marginBottom: '1rem',
    display: 'block',
    backgroundColor: backgroundColor || theme.palette.primary.main,
  },
}));

export const ShipBackButton = ({
  text,
  onClick,
  isDisabled,
  backgroundColor,
}) => {
  const {
    classes: { shipBackButtonStyle },
  } = useStyles({ backgroundColor });

  return (
    <Button
      variant="contained"
      color="primary"
      className={shipBackButtonStyle}
      onClick={onClick}
      disabled={isDisabled}
    >
      {text}
    </Button>
  );
};
